/**
 * Centralized env config. Use these constants instead of process.env in app code.
 * Only NEXT_PUBLIC_* and build-time vars are safe for client; server can read any env.
 *
 * Important: Next.js only inlines `process.env.NEXT_PUBLIC_*` when the property name is a
 * static string (e.g. process.env.NEXT_PUBLIC_PULSECHAIN). Dynamic access like
 * `process.env[key]` is NOT replaced in the client bundle, so values become undefined and
 * numeric IDs fall back to 0 — breaking `chainId === PULSECHAIN_ID` for wagmi reads.
 */

export const ENV = process.env.NEXT_PUBLIC_ENV ?? 'development'
export const isDevelopment = ENV === 'development'

export const PULSECHAIN_ID = parseInt(process.env.NEXT_PUBLIC_PULSECHAIN ?? '0', 10)
export const ETH_CHAIN_ID = parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN ?? '0', 10)

export const INTERCOM_APP_ID = process.env.NEXT_PUBLIC_INTERCOM_ID
